let resumeData = {
  name: "Tim",
  fullName: "Tim Nguyen",
  role: "Full-Stack Developer",
  linkedinId: "https://www.linkedin.com/in/timng93/",
  phone: "604-362-9472",
  email: "timgabrielnguyen@gmail.com",
  skypeid: "timng93",
  roleDescription:
    " I am a values driven developer that is motivated by complex problems and new knowledge of the web. Although I am relatively new to the world of code, my confidence grows daily as I take on increasingly challenging projects. My dedication, hard work, and ability to learn quickly are what make me a great asset to any team.",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/timng93/",
      className: "fa fa-linkedin"
    },
    {
      name: "github",
      url: "https://github.com/timng93",
      className: "fa fa-github"
    }
  ],
  aboutme:
    "I had graduated with a Bachelor in Biology from UBC. However, in the summer of 2018, I explored coding and it created a spark of interest. This interest in coding led to a career switch which included enrolling at RED Academy for the Full-Stack Developer Program.",
  address: "Vancouver Area",
  education: [
    {
      UniversityName: "Harvard University - Distance Education",
      specialization: "React Native Certificate",
      MonthOfPassing: "Currently Pursuing"
    },
    {
      UniversityName: "Red Academy - Vancouver BC",
      specialization: "Full Stack Diploma",
      MonthOfPassing: "Oct 2018 - Mar 2019"
    },
    {
      UniversityName: "Brain Station- Vancouver BC",
      specialization: "Certificate UX Design",
      MonthOfPassing: "Jun 2018 - Aug 2018"
    },
    {
      UniversityName: "University of British Columbia - Vancouver BC",
      specialization: "Bachelor of Science in Biology",
      MonthOfPassing: "Sep 2011 - May 2015"
    }
  ],
  work: [
    {
      CompanyName: "BC Sustainable Energy Association",
      specialization: "App Developer",
      MonthOfLeaving: "Mar",
      YearOfLeaving: "2019",
      Achievements:
        "Worked in a team of four to build an iOS app that helps students track environmental footprints, in under 3 weeks. Technologies involved: GraphQL, Apollo, React Native, Node. Queried data with GraphQL and built ReactNative interface."
    },
    {
      CompanyName: "UME Academy",
      specialization: "Web Developer",
      MonthOfLeaving: "Jan",
      YearOfLeaving: "2018",
      Achievements:
        "Worked in a team of four to build a WordPress arcade that showcases students games, in under 3 weeks. Technologies involved: WordPress, PHP, JavaScript, CSS. Programmed with PHP to display WordPress Content and styled CSS content."
    },
    {
      CompanyName: "Sunny Academy",
      specialization: "Private Tutor",
      MonthOfLeaving: "Feb 2016 - Sep 2018",
      Achievements:
        "Planned sessions and taught high school students Math and Science subjects. Provide ddetailed explanations and challenged students to go beyond the curriculum."
    }
  ],
  skills: [
    {
      skillname: "React/ React Native"
    },
    {
      skillname: "HTML5 & CSS3"
    },
    {
      skillname: "Javascript"
    },
    {
      skillname: "Node"
    },
    {
      skillname: "SQL"
    },
    {
      skillname: "MongoDB"
    },
    {
      skillname: "GraphQL"
    },
    {
      skillname: "Meteor"
    },
    {
      skillname: "WordPress"
    },
    {
      skillname: "PHP"
    },
    
  ],
  portfolio: [
    {
      name: "Inhabitent",
      description: "Wordpress Site built with PHP and SASS",
      imgurl: "images/home-hero.jpg",
      repo: "https://github.com/timng93/Inhabitent"
    },
    {
      name: "Quotes on Dev",
      description: "Responsive Wordpress Site built with PHP and SASS",
      imgurl: "images/desktop.png",
      repo: "https://github.com/timng93/Project-5-Quotes-on-Dev"
    },
    ,
    {
      name: "CoolIt",
      description: "iOs React Native App",
      imgurl: "images/coolIt.png",
      repo: "https://github.com/timng93/coolIt-winter-2019"
    },
    {
      name: "UME",
      description: "WordPress responsive site built with PHP",
      imgurl: "images/ume.png",
      repo: "https://github.com/timng93/ume-fall-2018"
    }
  ]
};

export default resumeData;
